import { LoadingOverlayStyle } from '../../../styles/components/common/layout';
export interface ILoadingOverlayProps {
  show: boolean;
}

const LoadingOverlay = (props: ILoadingOverlayProps) => {
  return (
    <div
      className={`${LoadingOverlayStyle['loading-wrapper']} ${
        props.show ? LoadingOverlayStyle['show'] : ''
      }`}>
      <div className={'loader-ellipsis'}></div>
    </div>
  );
};

export default LoadingOverlay;
